import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import Term from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/Term.jsx';
import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import { PurchaseMethods, CurrencyFormats, ModelYear } from '@sm360/widget-commons-vehicle';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.scss';

class CalculatorTerms extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(value) {
        this.props.actions.selectTerm(value);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_DURATION(value, this.props.modelYear.model, this.props.modelYear.year)
        );
    }

    render() {
        const selectedTerm = this.props.purchaseMethods.getSelectedFinanceTerm();
        const terms = this.props.purchaseMethods.lease.selected
            ? this.props.purchaseMethods.lease.terms
            : this.props.purchaseMethods.finance.terms;
        const paymentFrequencyLabels = this.props.purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);
        const termsBlock = terms.map((term) => {
            return (
                <Term
                    key={term.term}
                    paymentFrequencyLabels={paymentFrequencyLabels}
                    payment={LocaleService.l(term.calculatedPayment, CurrencyFormats.CURRENCY_2)}
                    term={term.term}
                    apr={
                        !term?.aprDetails?.creditRate || !this.props.displayCreditRate
                            ? term.apr
                            : term?.aprDetails?.creditRate
                    }
                    handleClick={this.handleClick}
                    selectedTerm={selectedTerm}
                    purchaseMethods={this.props.purchaseMethods}
                    config={this.props.config}
                    displayCreditRate={this.props.displayCreditRate}
                />
            );
        });

        return <div className="calculator-terms clearfix">{termsBlock}</div>;
    }
}

CalculatorTerms.defaultProps = {
    displayCreditRate: false,
};

CalculatorTerms.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    actions: PropTypes.shape({
        selectTerm: PropTypes.func.isRequired,
    }),
    displayCreditRate: PropTypes.bool,
};

CalculatorTerms.displayName = 'CalculatorTerms';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        modelYear: state.modelYear,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalculatorTerms);
export { CalculatorTerms };
